import React, { createContext, useState, useEffect } from 'react';
import {useLocation} from "react-router-dom";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const location = useLocation();
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  // get project name from query params
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const projectName = params.projectName || 'Default'

  // get the url based on the current page
  const url = () => {
    if (location.pathname.includes('card-capture')) {
      return `https://lnesv3-conf.ado-tech.com/${projectName}/CardCapture/config.json`;
    }
    return `https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`;
  }
  const defaultUrl = () => {
    if (location.pathname.includes('card-capture')) {
      return `https://lnesv3-conf.ado-tech.com/Default/CardCapture/config.json`;
    }
    return `https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`;
  }

  function refetch() {
    fetchConfig();
  }
  function setStyles(stylesObject) {
    const root = document.documentElement;
    root.style.setProperty('--background-color', stylesObject.backgroundColor);
    root.style.setProperty('--message-color', stylesObject.messageColor);
    root.style.setProperty('--message-back-color', stylesObject.messageBackgroundColor);
    root.style.setProperty('--guide-color', stylesObject.guideColor);
    root.style.setProperty('--success-color', stylesObject.successColor);
    root.style.setProperty('--error-color', stylesObject.errorColor);
    root.style.setProperty('--message-error-color', stylesObject.messageErrorColor);
    root.style.setProperty('--font-size', stylesObject.fontSize);
  }

  const fetchConfig = async () => {
    try {
      if (!params.projectName || params.projectName === 'undefined') {
        console.warn('No projectName provided, using default config');
        const response = await fetch(defaultUrl(), { method: 'GET' });
        const data = await response.json();
        setConfig(data);
        if (data.styles) {
          setStyles(data.styles);
        }
      } else {
        const response = await fetch(url(), { method: 'GET' });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
         setConfig(data);
        if (data.styles) {
          setStyles(data.styles);
        }
      }
    } catch (error) {
      console.error("Failed to fetch config:", error);
      try {
        const response = await fetch(defaultUrl(), { method: 'GET' });
        const data = await response.json();
        setConfig(data);
        if (data.styles) {
          setStyles(data.styles);
        }
      } catch (fallbackError) {
        console.error("Failed to fetch default config:", fallbackError);
        setConfig({});
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchConfig();
  }, [location.pathname]);

  return (
    <ConfigContext.Provider value={{ value: config, refetch, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};
